import React, { useEffect } from 'react';
import { Accordion, Form } from 'react-bootstrap';
import { useGetActiveColorMutation } from '../../../Redux/ColorSlice';

const ProductSelectColor = ({ selectedColors, setSelectedColors,limit,page,setPage,setlimit,search,setSearch }) => {
  const [productListFn, { data: productList, isSuccess, error, isLoading }] = useGetActiveColorMutation();

  useEffect(() => {
    productListFn()
  }, [])

  return (
    <React.Fragment>
      <Accordion defaultActiveKey='0'>
        <Accordion.Item eventKey='0'>
          <Accordion.Header>
            <span className="text-muted text-uppercase fs-13">Colors</span>
          </Accordion.Header>

          <Accordion.Body className="text-body">
            <ul className="clothe-colors list-unstyled hstack gap-3 mb-0 flex-wrap" id="color-filter">
              {
                productList?.response?.map(color => {
                  const isExit = selectedColors?.includes(color?.id)

                  return <li key={color?.id} style={{ position: 'relative', borderRadius: "50%", border: "3px" }} >
                    {isExit ? <span className='position-absolute top-0 left-50 w-100 h-100 ms-2 mt-1 text-white' style={{ zIndex: 887, pointerEvents: "none" }} ><i class="ri-check-line"></i></span> : null}

                    <Form.Check type="radio" name="colors" value="success" id="color-1" />
                    <Form.Label onClick={() => {

                    
                        setPage(1)
                    
                      setSelectedColors(isExit ? selectedColors?.filter(c => c !== color?.id) : [...selectedColors, color?.id])
                    }} style={{ backgroundColor: color?.hexCode }} className="avatar-xs btn btn-success p-0 d-flex align-items-center justify-content-center rounded-circle" htmlFor="color-1"></Form.Label>

                  </li>
                })
              }
            </ul>

          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

    </React.Fragment>
  );
};

export default ProductSelectColor;
